import { colors } from "../../../style";

// Series colours are stepped from the brand teal/violet/amber so they stay
// distinguishable under colour-blindness on the dark surface. The raw brand
// teal and violet are too close to each other to carry identity.
export const series = {
  inbound: "#18a19c",
  outbound: "#7d72e3",
  internal: "#c98500",
};

export const directionLabels = {
  inbound: "Inbound",
  outbound: "Outbound",
  internal: "Internal",
};

// Diverging: red (negative) -> grey midpoint -> teal (positive).
export const sentimentScale = {
  1: "#e66767",
  2: "#a8616d",
  3: "#5d5e72",
  4: "#1f8581",
  5: "#2cc2bc",
};

export const sentimentLabels = {
  1: "Very negative",
  2: "Negative",
  3: "Neutral",
  4: "Positive",
  5: "Very positive",
};

// Single-hue teal ramp for magnitude (heatmap), dark surface -> bright.
export const heatRamp = [
  "#283044",
  "#1d4a52",
  "#16636a",
  "#127e80",
  "#169a97",
  "#2ab7b1",
  "#5fd3cb",
];

export const chart = {
  surface: colors.surface,
  grid: "rgba(255, 255, 255, 0.06)",
  axis: "rgba(255, 255, 255, 0.14)",
  tick: colors.textLight,
  cursor: "rgba(255, 255, 255, 0.05)",
  good: "#0ca30c",
  critical: "#e66767",
  font: 12,
};

export const axisProps = {
  tick: { fill: chart.tick, fontSize: chart.font },
  tickLine: false,
  axisLine: { stroke: chart.axis },
};

export const sentimentRating = (score) =>
  Math.min(5, Math.max(1, Math.ceil((Number(score) || 0) / 20)));

export const formatMinutes = (minutes) => {
  const m = Math.round(minutes);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return rem ? `${h}h ${rem}m` : `${h}h`;
};

export const formatNumber = (n) => Number(n || 0).toLocaleString("en-GB");
